import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=67e99a70&scoped=true&"
import script from "./weight.vue?vue&type=script&lang=js&"
export * from "./weight.vue?vue&type=script&lang=js&"
import style0 from "./weight.vue?vue&type=style&index=0&id=67e99a70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e99a70",
  null
  
)

export default component.exports